import React from "react";
import Header from "../header/Header";
import AssetsTable from "./TokenTable/AssetsTable";
import AssetsAccount from "./AssetsAccount/AssetsAccount";

const Home = () => {
  return (
    <div>
      <Header />
      <div className="inline-block 2xl:inline-flex w-full">
        <div className="w-full">
          <AssetsTable />
        </div>
        <div className="w-full 2xl:w-[349px]">
          <AssetsAccount />
        </div>
      </div>
    </div>
  );
};

export default Home;
